<template>
    <div role="tabcard" class="tab-pane" id="new-selection">
        <div class="card card-default">
            <div class="card-header">
                <div class="d-inline-block card-header-content">
                    <div class="title">{{ title }}</div>
                    <div v-if="isDraft">Draft selections are not visible to customers until they are released.</div>
                </div>
                <div class="d-inline-block float-right">
                </div>
            </div>
            <div class="card-body">
                <selection-form :project="project" :changeorders="changeorders" v-bind:is-editing="false" :isDraft="isDraft"></selection-form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['role', 'project', 'changeorders', 'isDraft'],
        
        created: function() {
        },

        mounted: function() {

        },

        data: function() {
            return {
            };
        },

        computed: {
            title: function() {
                if (this.isDraft) return 'New draft selection';
                return 'New material selection';
            }
        },

        watch: {
        },

        methods: {
        }
    }
</script>
